<template>
    <div
        class="md user-audio"
        :class="[isPlayAudio? '' :'none']"
    >
        <a @click.prevent.stop="soundChange" :title="$t('site.func.audio')"></a>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'

    export default {
        computed: {
            ...mapState([
                'isPlayAudio',
            ]),
        },
        methods: {
            ...mapMutations([
                'soundChange',
            ]),
        },
        watch: {
            isPlayAudio: {
                handler: function(){
                    let $audio = document.querySelector('audio');
                    
                    if (this.isPlayAudio) {
                       $audio.play()
                    }else{
                        $audio.pause();
                    }
                },
            },
        },
    }
</script>

<style scoped lang="scss">

    .md.user-audio {
        @extend %header-btn-caption;

        &.none {

            > a {

                &::before {
                    content: '\e04f';
                }
            }
        }

        > a {

            &::before {
                content: '\e050';
            }
        }

        @include media('mobile') {
            display: none;
        }
    }
</style>
